import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-actions }}\n<SideBySide::Setup />",{ moduleName: "embercom/templates/apps/app/side_by_side/zendesk/index.hbs" })